const { SET_BEAUTY_OFFER } = require('../../constants/actionTypes/beautyOffer');

const initialState = {};

const reducer = function (state = initialState, action) {
    const {
        type, payload
    } = action;

    switch (type) {
        case SET_BEAUTY_OFFER: {
            const { data } = payload;
            return {
                ...initialState,
                ...data
            };
        }
        default: {
            return state;
        }
    }
};

module.exports = reducer;
